type FieldsPaneEventName = keyof GlobalEventHandlersEventMap & `fields-pane-${string}`;

/** A typed, non-bubbling custom event of this package; the name decides the detail type through the global event map */
export default function createEvent<T extends CustomEvent>(name: FieldsPaneEventName, detail?: T["detail"]): CustomEvent<T["detail"]> {
    return new CustomEvent(name, { detail, bubbles: false, cancelable: false, composed: false });
}
